import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FilterWrapper from './../FilterWrapper';
import { useLanguage } from './../../../../../../context/LanguageContext';

const TimeRangeFilter = props => {
  const { labels } = useLanguage();
  const FILTER_BAR = labels.FILTER_BAR || {};
  const [state, setState] = useState({
      dropOpen: false,
      selectedItems: [],
      startInclusive: props.startInclusive,
      endInclusive: props.endInclusive
    });

  useEffect(() => {
    setSelectedItems([state.startInclusive, state.endInclusive]);
  },[])

  useEffect(() => {
    let initialDates = [props.startInclusive, props.endInclusive];
    initialDates = initialDates.filter(item => item);

    setState(state => (
      {
        ...state,
        startInclusive: props.startInclusive,
        endInclusive: props.endInclusive,
        selectedItems: initialDates
      }));
  },[props.startInclusive, props.endInclusive, state.dropOpen])

  const onDateChange = (event, id) => {
    event.persist();
    setState(state => ({ ...state, [id]: event.target.value }));
    setSelectedItems([state.startInclusive, state.endInclusive]);
  }

  const onCloseFilter = () => {
    let { startInclusive, endInclusive } = state;
    props.updateLocalFilterPayload({
      [props.filterKey]: {
        startInclusive: startInclusive || null,
        endInclusive: endInclusive || null
      }
    });
  }

  const setSelectedItems = (items) => {
    items = items.filter(item => item);
    setState(state => ({ ...state, selectedItems: items }));
  }

  const filterWrapperProps = {
    changesInFilter: state.selectedItems.length,
    id: props.id,
    isUserAdded: props.isUserAdded,
    name: props.name,
    onCloseFilter: onCloseFilter,
    removeFilter: props.removeFilter,
  };

  return (
    <FilterWrapper
      {...filterWrapperProps}
    >
      <div style={{ display: 'flex' }}>
        <TextField
          type="time"
          id="startInclusive"
          className="search-field-date"
          label={FILTER_BAR?.TIME?.FROM}
          onChange={(e) => onDateChange(e, 'startInclusive')}
          value={state.startInclusive}
          maxdate={state.endInclusive}
          InputLabelProps={{
            shrink: true,
          }}
          variant="standard"
        />
        <TextField
          type="time"
          id="endInclusive"
          className="search-field-date"
          label={FILTER_BAR?.TIME?.TO}
          onChange={(e) => onDateChange(e, 'endInclusive')}
          value={state.endInclusive}
          mindate={state.startInclusive}
          InputLabelProps={{
            shrink: true,
          }}
          variant="standard"
        />
      </div>
    </FilterWrapper>
  );
}

TimeRangeFilter.propTypes = {
  startInclusive: PropTypes.any,
  endInclusive: PropTypes.any,
  filterKey: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
};

TimeRangeFilter.defaultProps = {
  isUserAdded: false,
  items: [],
  removeFilter: () => {},
  startInclusive: null,
  endInclusive: null
};

export default TimeRangeFilter;